import throttle from "lodash/throttle";
import { useEffect } from "react";

export type GetScrollValueReturn = {
  clientHeight: number;
  innerHeight: number;
  scrollY: number;
};

export const getScrollValues = (): GetScrollValueReturn => ({
  clientHeight:
    typeof window !== "undefined" ? window.document.body.clientHeight : 0,
  innerHeight: typeof window !== "undefined" ? window.innerHeight : 0,
  scrollY: typeof window !== "undefined" ? window.scrollY : 0,
});

export const useScrollEffect = (
  onScroll: (
    clientHeight: number,
    innterHeight: number,
    scrollY: number
  ) => void,
  handleScrollInterval = 100
): void => {
  const handleScroll = throttle(() => {
    const { clientHeight, innerHeight, scrollY } = getScrollValues();
    onScroll(clientHeight, innerHeight, scrollY);
  }, handleScrollInterval);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);
};
